import React from 'react';

// WEB-9: className стал параметром. Раньше он был жёстко прибит строкой 'auth',
// поэтому одно и то же поле выглядело одинаково везде, где его ни поставь, а
// новая страница входа не могла оформить своё поле, не перекрашивая заодно
// все остальные. Значение по умолчанию оставлено прежним — вызовы, которые
// className не передают, ведут себя байт-в-байт как раньше.
const Input = ({ type = 'text', placeholder, value, onChange, id, className = 'auth', autoComplete }) => {
    return (
        <input
            className={className}
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            id={id}
            autoComplete={autoComplete}
        />
    );
};

export default Input;
